<template>
  <div v-if="item && item.product && item.product.id">
   
    <fields-list :item="item" :fields="fields" />
       <div class="save-panel">
      <button class="btn btn-sm btn-success btn-icon mt-4" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
  <div v-else><h6>В разделе "Модификация" установите группу и сохраните</h6></div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

import FieldsList from "../FieldsList";

export default {
  data: () => ({
    cardLink: "products/card",
    cardSetLink: "products/product",
    item: null,
    fields: [
      {
        key: "product",
        label: "Информация о товаре",
        type: "object",
        subFields: [
          {
            key: "is_active",
            label: "Активен",
            type: "checkbox",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            key: "title",
            label: "Доп.название",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            key: "vendor_code",
            label: "Артикул",
            type: "field",
            textType: "text",
          },
          {
            col: "col-md-6 col-12",
            label: "Бренд",
            key: "brand",
            type: "select",
            selectKey: "title",
            modal: "brands",
            prefix: "product",
          },
          {
            col: "col-md-6 col-12",
            label: "Класс",
            key: "name",
            type: "select",
            selectKey: "title",
            modal: "name",
                        prefix: "product",
          },
          {
            key: "category",
            selectKey: "full_title",
            label: "Категория-(и)",
            type: "selects",
            modal: "categories",
             prefix: "product",
          },
        ],
      },
    ],
  }),
  components: {
    FieldsList,
  },
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    updateItem() {
      this.cardUpdate(this.cardSetLink, this.item);
    },
  },
};
</script>
<style>
</style>
